<template>
  <div class="personalInfo">
    <el-card>
      <el-form :model="form" :rules="rules" ref="form" :label-width="require('@/config/enum').c_w4"
        :label-suffix="require('@/config/enum').c_colon">
        <!-- 登录账号 -->
        <el-form-item :label="$t('lang.lab_loginAccount')" prop="userId">
          <el-input v-model="form.userId" disabled
            :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_loginAccount')"
            onkeyup="this.value=this.value.replace(/[^\d.]/g,'');" class="inputdis"></el-input>
        </el-form-item>
        <!-- 密码 -->
        <!-- <el-form-item :label="$t('lang.lab_password')" prop="password">
          <el-input v-model="form.password" show-password :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_password')" maxlength="15" class="inputdis"></el-input>
        </el-form-item> -->
        <!-- 姓名 -->
        <el-form-item :label="$t('lang.lab_name')" prop="nickName">
          <el-input v-model="form.nickName" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_name')"
            class="inputdis"></el-input>
        </el-form-item>
        <!-- 电话 -->
        <el-form-item :label="$t('lang.lab_tele')" prop="mobile">
          <el-input v-model="form.mobile" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_tele')"
            maxlength="11" class="inputdis"></el-input>
        </el-form-item>
      </el-form>
      <el-button type="" class="btn-first" @click="showDialog">修改密码</el-button>
      <el-button type="primary" :disabled="isDisabled" class="btn-first" @click="save('form')">{{$t('lang.btn_save')}}
      </el-button>
      <el-dialog title="修改密码" :visible.sync="dialogVisible" :before-close="hideDialog" width="30%">
        <el-form ref="formPsd" :model="formPsd" :rules="rulesPsd" label-width="80px">
          <el-form-item label="原密码" prop="oldPsd">
            <el-input type="password" v-model="formPsd.oldPsd"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPsd">
            <el-input type="password" v-model="formPsd.newPsd"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="configPsd">
            <el-input type="password" v-model="formPsd.configPsd"></el-input>
          </el-form-item>
          <el-form-item style="float:right;">
            <el-button @click="hideDialog">取消</el-button>
            <el-button type="primary" @click="editPsd('formPsd')">立即修改</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:personalInfo
   *@Description:个人信息
   *@author:李斌
   *@Copyright:格众科技
   *@date:2020-04-20
   */
  export default {
    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_password')))
        } else if (value.length < 6 || value.length > 15) {
          callback(new Error(this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_frSixToFifteen')))
        } else {
          callback()
        }
      }
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'))
        } else if (value !== this.formPsd.newPsd) {
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback()
        }
      }
      return {
        isDisabled: true, // 按钮置灰
        saveData: '', // 存储json字符串
        form: {
          userId: this.$store.getters.userData.account, // 登录账号
          password: this.$store.getters.userData.password, // 密码
          nickName: this.$store.getters.userData.nickName, // 姓名
          mobile: this.$store.getters.userData.mobile, // 电话
        },
        rules: {
          userId: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_loginAccount'),
            trigger: 'blur'
          }],
          password: [{
            required: true,
            validator: validatePass,
            trigger: 'blur'
          }],
          nickName: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_name'),
            trigger: 'blur'
          }],
        },
        dialogVisible: false,
        formPsd: {
          oldPsd: '',
          newPsd: '',
          configPsd: '',
        },
        rulesPsd: {
          oldPsd: [{
            required: true,
            validator: validatePass,
            trigger: 'blur'
          }],
          newPsd: [{
            required: true,
            validator: validatePass,
            trigger: 'blur'
          }],
          configPsd: [{
            required: true,
            validator: validatePass2,
            trigger: 'blur'
          }]
        },

      }
    },
    created() {
      this.saveData = JSON.stringify(this.form)
    },
    watch: {
      form: {
        handler(newVal, oldVal) {
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            this.isDisabled = true
          } else {
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      save(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let loading = this.$loading()
            let params = {
              // pwd: this.form.password,
              nickName: this.form.nickName,
              mobile: this.form.mobile,
            }
            this.$patch(
              `/admins/self`,
              params
            ).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.$router.push('/')
                }
              },
              error => {
                loading.close()
                this.diaIsShow = false
                this.$message.error(error)
              }
            )
          }
        })
      },
      // 显示弹窗 
      showDialog() {
        this.dialogVisible = true
      },
      // 隐藏弹窗 
      hideDialog() {
        this.dialogVisible = false
        this.formPsd.oldPsd = ''
        this.formPsd.newPsd = ''
        this.formPsd.configPsd = ''
        this.$refs.formPsd.clearValidate()
      },
      // 修改密码
      editPsd(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (this.formPsd.oldPsd == this.formPsd.newPsd) {
              this.$message.info('新密码和旧密码一致')
            } else {
              let loading = this.$loading()
              let params = {
                oldPassword: this.formPsd.oldPsd,
                newPassword: this.formPsd.newPsd,
              }
              this.$post(`/staffs/updatePassword`, params).then(res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success('修改成功')
                    // this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.$router.push('/')
                  }
                },
                error => {
                  console.log(error)
                  loading.close()
                  this.$message.error('原密码输入错误，请重试')
                }
              )
            }
          }
        })
      }
    }
  }
</script>

<style lang='scss'>
  .personalInfo {
    .inputdis {
      width: 30%;
    }
  }
</style>